// NP-4 — optimistic concurrency, client side.
//
// Every saved Activity and Session has an integer `revision` on the server
// (1 for a new record, +1 on every update; a record saved before NP-4 has
// none and counts as 0). The client remembers the revision of the record
// it loaded or last saved, and sends it back as `baseRevision` when it
// updates that record, so the server can refuse a save made from an
// out-of-date copy.
//
// The workspace keeps `null` when nothing persisted is open (a new,
// unsaved workspace or tab): that is "no record", not revision 0.

// Revision of a record returned by the server (load or save). The server's
// value is authoritative; a record without one is a legacy record → 0.
export function revisionOf(record) {
  const r = record ? record.revision : undefined;
  return Number.isInteger(r) && r >= 0 ? r : 0;
}

// Save payload with `baseRevision` added for a normal update of a persisted
// record, and never for Save As New (an insert) or when nothing persisted
// is open (no id, or no known revision).
export function withBaseRevision(payload, { isNew, revision }) {
  const { baseRevision: _drop, ...rest } = payload;
  if (isNew || !rest.id || !Number.isInteger(revision) || revision < 0) return rest;
  return { ...rest, baseRevision: revision };
}
